import init from '../../helpers/init';

const {$, _} = init;
const BX = (<any>window).BX;

$(() => {
  let tableClass = '.js-office-ads-list';

  if($(tableClass).length) {

    // таблица
    let tableList = $(tableClass).DataTable({
      'language': (BX.message('LANGUAGE_ID') === 'en' ? {
        emptyTable: 'Missing data in the table',
        info: '_START_ - _END_ from _TOTAL_',
        infoEmpty: '0 from 0',
        infoFiltered: '(Filtered records of _MAX_)',
        infoPostFix: '',
        thousands: ',',
        lengthMenu: 'Elements per page _MENU_ ',
        loadingRecords: 'Loading...',
        processing: 'Loading...',
        search: 'Search:',
        zeroRecords: 'Not found',
        paginate: {
          first: 'First',
          last: 'Last',
          next: 'Next',
          previous: 'Previous'
        },
        aria: {
          sortAscending: ': activate the column to sort column ascending',
          sortDescending: ': activate the column to sort column descending',
          paginate: {
            first: 'First',
            last: 'Last',
            next: 'Next',
            previous: 'Previous'
          }
        }
      } : {
        emptyTable: 'Данные отсутствуют',
        info: '_START_ - _END_ из _TOTAL_',
        infoEmpty: '0 из 0',
        infoFiltered: '(Отфильтровано из _MAX_ записей)',
        infoPostFix: '',
        thousands: ',',
        lengthMenu: 'Выводить по _MENU_ ',
        loadingRecords: 'Загрузка...',
        processing: 'Загрузка...',
        search: 'Поиск: ',
        zeroRecords: 'Ничего не найдено',
        paginate: {
          first: 'Первый',
          last: 'Последний',
          next: 'Следующий',
          previous: 'Предыдущий'
        },
        aria: {
          sortAscending: ': активировать для сортировки столбца по возрастанию',
          sortDescending: ': активировать для сортировки столбца по убыванию',
          paginate: {
            first: 'Первый',
            last: 'Последний',
            next: 'Следующий',
            previous: 'Предыдущий'
          }
        }
      }),
      'columns': [
        {name: 'checkbox', data: 'checkbox', searchable: false, orderable: false, width: '20px'},
        {name: 'name', data: 'name', searchable: true, orderable: true, width: '20%'},
        {name: 'author', data: 'author', searchable: false, orderable: true, width: '20%'},
        {name: 'role', data: 'role', searchable: false, orderable: false, width: '10%'},
        {name: 'date_create', data: 'date_create', searchable: false, orderable: true},
        {name: 'status', data: 'status', searchable: false, orderable: false},
        {name: 'actions', data: 'actions', searchable: false, orderable: false},
      ],
      'order': [[4, 'asc']],
      'lengthMenu': [
        [10, 20, 50, 100, 1000],
        [10, 20, 50, 100, (BX.message('LANGUAGE_ID') === 'en' ? 'All' : 'Все')]
      ],
      'processing': true,
      'serverSide': true,
      'stateSave': true,
      'stateDuration': -1,
      'ajax': {
        'url': '/local/ajax/office/Ads/list/?lang='+(BX.message('LANGUAGE_ID') === 'en' ? 'en' : 'ru'),
        'type': 'POST'
      }
    });

    // выбираем все checkbox
    $(document).on('change', 'input[type="checkbox"].js-office-list-check-all', function(){
      if($(this).prop('checked')){
        $('input[type="checkbox"].js-office-list-check-item').each(function(){
          if(!$(this).prop('checked')){
            $(this).prop('checked', true);
          }
        });
      }else{
        $('input[type="checkbox"].js-office-list-check-item').each(function(){
          if($(this).prop('checked')){
            $(this).prop('checked', false);
          }
        });
      }
    });

    // фильтрация
    $(document).on('change', 'select.js-list-filter', function(){
      let v = $(this).val();
      let name = $(this).attr('name');

      if(v !== undefined && v !== null && v != '' && name !== undefined && name !== null){
        BX.setCookie(name, v, {path: '/'});
      }else{
        BX.setCookie(name, 1, {path: '/', expires: -1});
      }

      tableList.ajax.reload();
    });

    // действия
    $(document).on('click', '.js-office-change-status', function(event){
      event.preventDefault();
      let url = $(this).attr('href');
      if(url){
        setAdStatus(url, function(){tableList.ajax.reload();});
      }
    });

    // действие с комментом
    $(document).on('click', '.js-office-change-status-with-comment', function(event){
      event.preventDefault();
      let url = $(this).attr('href');
      if(url && $('#popupOfficeAdsListChangeStatus').length){
        $('#popupOfficeAdsListChangeStatus form.js-change-ads-office-comment-form').attr('action', url);
        $('#popupOfficeAdsListChangeStatus').modal('show');
      }
    });

    // закрытие модалки
    $('#popupOfficeAdsListChangeStatus').on('hidden.bs.modal', function () {
      if($('#popupOfficeAdsListChangeStatus form').length){
        $('#popupOfficeAdsListChangeStatus form').trigger('reset');
        $('#popupOfficeAdsListChangeStatus form.js-change-ads-office-comment-form').attr('action', '');
      }
    });

    // отправка коммента при смене статуса
    $(document).on('submit', 'form.js-change-ads-office-comment-form', function(event){
      event.preventDefault();
      let form = $(this);
      let comment = form.find('textarea[name="COMMENT"]').val();
      let url = form.attr('action');
      if(url) {
        if (comment) {
          setAdStatus(url + '&COMMENT=' + comment, function(){tableList.ajax.reload();});
          $('#popupOfficeAdsListChangeStatus').modal('hide');
        } else {
          alert(BX.message('LANGUAGE_ID') === 'en' ? 'Empty comment' : 'Пустой комментарий');
        }
      }
    });

    //массовые действия
    $(document).on('change', 'select.js-office-list-mass-action', function(){
      let v = $(this).val();
      let selector = $(this);
      if(v){
        let ids: string[];
        ids = [];
        $('input[type="checkbox"].js-office-list-check-item:checked').each(function(){
          if($(this).val()){
            ids.push($(this).val().toString());
          }
        });
        if(ids.length) {
          $.ajax(
            {
              method: 'POST',
              url: '/local/ajax/office/Ads/changeStatusMass/',
              data: {
                id: ids,
                status: v
              },
              dataType: 'text'
            }
          ).done(function (data) {
            selector.prop('selectedIndex',0);
            tableList.ajax.reload();
          });
        }
      }
    });
  }

  /**
   * устанавливает статус для объявления
   * @param string link
   * @param funciton f
   */
  let setAdStatus = function(link: string, f: () => void){
    if(link) {
      $.ajax(
        {
          method: 'GET',
          url: link,
          dataType: 'text'
        }
      ).done(function (data) {
        if(f !== undefined) {
          f();
        }
      });
    }
  }

  // обработка деталки
  $(document).on('keyup', '.js-ads-textarea-field', function(){
    let area = $(this);
    let v = area.val().toString();
    let m = area.attr('maxlength');
    if(m && m !== undefined){
      let res = parseInt(m) - v.length;
      area.find('+.js-ads-textarea-symb-counter').html(res.toString());
    }
  });

  // смена статуса из деталки
  $(document).on('click', '.js-ads-detail-change-status', function(event){
    event.preventDefault();

    let url = $(this).attr('href');
    let needComment = $(this).attr('data-need-comment');
    let changeStatus = true;
    if(needComment !== undefined && needComment.toString() == '1'){

      if(!$('.js-ads-comment-textarea-field').length){
        alert(BX.message('LANGUAGE_ID') === 'en' ? 'Empty comment' : 'Пустой комментарий');
        changeStatus = false;
      }else{
        let comment = $('.js-ads-comment-textarea-field').val();
        if (comment && comment.toString().length) {
          url = url + '&COMMENT=' + comment.toString();
        } else {
          alert(BX.message('LANGUAGE_ID') === 'en' ? 'Empty comment' : 'Пустой комментарий');
          changeStatus = false;
        }
      }
    }

    if(changeStatus){
      if(url){
        setAdStatus(url, function(){location.reload()});
      }
    }

  });
});
